import { Action } from 'react-fetching-library';

export const getUserList: Action = {
  method: 'GET',
  endpoint: 'users',
};
